<template>
  <div class="pageDiv">
    <v-card class="main-card" v-if="!$AuthSvc.isLogin() || !$AuthSvc.isAdmin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Config Admin</span>
      </v-card-title>

      Must login as ADMIN to view data
    </v-card>

    <v-card class="home-card" v-if="$AuthSvc.isLogin() && $AuthSvc.isAdmin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Config Admin</span>
      </v-card-title>

      <div>
        <v-card class="aCard">
          <v-card-text>
            <v-card-title style="padding-bottom:0">
              <span class="">Set Configurations</span>
            </v-card-title>

            <v-card class="config-card">
              <div class="inputItem">
                <span class="label14">Current Year: </span> <input class="text-input" v-model="currentYear"/>
              </div>
              <div style="display:inline-block;width:100%;margin-top:20px">
                <v-btn class="primary-btn" @click="saveConfigYear()">Save</v-btn>
              </div>
            </v-card>

            <br>

            <v-card class="config-card">
              <v-card-text  style="margin-bottom:20px">
                <div>
                  <span class="label20">Current Sponsor</span>
                </div>

                <br>

                <div>
                  <span class="label14">Show Sponsor: </span>
                  <input class="checkbox" type="checkbox" v-model="showSponsor"/>
                </div>

                <br>

                <div class="inputItem">
                  <span class="label14">Sponsor Name: </span>
                  <input class="text-input" v-model="sponsor.sponsorName"/>
                </div>

                <div class="inputItem">
                  <span class="label14">Tournament Name: </span>
                  <input class="text-input" v-model="sponsor.tournamentName"/>
                </div>

                <div class="inputItem">
                  <span class="label14">Tournament Date: </span>
                  <input class="text-input" v-model="sponsor.tournamentDate"/>
                </div>

                <div id="image-div-id" style="display:inline-block;">
                  <div class="flex-container">
                    <div>
                      <br>
                      <span class="label16">Choose an image:</span><br>
                      <v-btn class="upload-btn" v-on:click="uploadSponsorImage()"
                             :disabled="(fileName === null || fileName === '')">
                        Upload
                      </v-btn>
                      <input id="choose-file-id" style="padding:5px 10px" type="file" @change="handleFileUpload( $event )"/>
                    </div>
                  </div>

                  <div class="sponsor-img-div">
                    <div class="loader" v-if="isBusy"></div>
                    <img class="flyer-image"
                         :src="$AuthSvc.getFlyerUrl()" >
                  </div>
                </div>

              </v-card-text>

              <div style="display:inline-block;width:100%;margin: 10px 0 20px 0">
                <v-btn class="primary-btn" @click="saveConfigSponsor()">Save</v-btn>
              </div>
            </v-card>

          </v-card-text>
        </v-card>
      </div>

    </v-card>
  </div>
</template>

<script>
  import moment from 'moment';
  import swal from 'sweetalert';

    export default {
      name: "login",
      data: () => ({
        file: null,
        fileName: '',
        showSponsor:  false,
        currentYear: '',
        sponsor: {
                    'showSponsor': 'N',
                    'sponsorName': '',
                    'tournamentName': '',
                    'tournamentDate': ''
                 }
      }),
      mounted: function() {
        this.$AuthSvc.authenticated(this.load);
      },
      methods: {
        load() {      
            var _this = this;

            _this.$CommandSvc.get(_this, '/public/config/current-year',
                function (data) {
                  _this.currentYear = data;
                },
                function (error) {
                    console.log('ERROR: ' + error);
                });

            _this.$CommandSvc.get(_this, '/public/config/current-sponsor',
                function (data) {
                  if (data !== '') {
                      _this.sponsor = data;
                      _this.showSponsor = _this.sponsor.showSponsor === 'Y';
                  }
                },
                function (error) {
                    console.log('ERROR: ' + error);
                });
        },
        saveConfigYear() {
          this.axios.post('/admin/config/' + this.currentYear, null)
          .then(function (response) {
              console.log('SAVE Conifg Successful ' + response.data);
              swal("Success", "Config saved.", "info");
          })
          .catch(function (error) {
              swal("Error", "Config FAILED save.", "error");
              console.log('ERROR: ' + error);
          });
        },
        saveConfigSponsor() {
          this.sponsor.showSponsor = this.showSponsor ? "Y" : "N";
          this.axios.post('/admin/config/sponsor', this.sponsor)
          .then(function (response) {
              console.log('SAVE Conifg Successful ' + response.data);
              swal("Success", "Config saved.", "info");
          })
          .catch(function (error) {
              swal("Error", "Config FAILED save.", "error");
              console.log('ERROR: ' + error);
          });
        },
        handleFileUpload( event ){
          this.file = event.target.files[0];
          this.fileName=this.file.name;
        },
        uploadSponsorImage() {
          var _this = this;

          _this.isBusy = true;

          let formData = new FormData();
          formData.append('file', this.file);

          this.axios.post(_this.$AuthSvc.putFlyerUrl(),
            formData,
            {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
            }
          ).then(function() {
            _this.isBusy = false;
            document.getElementById("choose-file-id").value = "";
            swal("Success", "Image uploaded successfully.", "info")
             .then((willDelete) => {
                window.location.reload();
             });
            console.log('SUCCESS!!');
          })
          .catch(function(error){
            _this.isBusy = false;
            swal("Problem", "Unable to load image.", "error");
            console.log('FAILURE!! ' + error);
          });
        }
      }
    }

</script>

<style scoped>
  .checkbox {
    height: 20px;
    width: 20px;
  }

  .home-card {
    padding: 20px;
  }

  .label {
    font-size: 14px;
    font-weight: bold;
    display: inline-block;
    width: 100px;
  }

  .player-card {
    margin: 10px 0;
    padding: 10px;
  }

  .player-content {
    display: inline-block;
    float: left;
    width: 70%;
    height: auto;
    vertical-align: top;
  }

  .text-message {
    border: 2px solid black;
    border-radius: 5px;
    padding: 10px !important;
    margin-top: 30px;
  }

  .event-card {
      padding: 7px !important;
  }

  .add-button {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .inputItem {
    padding: 5px;
  }

  .inputItem  > input {
    width: 100%;
  }

  .flyer-image {
    margin-top: 20px;
    width: 100%;
  }

  .primary-btn {
    display: inline-block;
    margin-right: 10px;
  }

  .upload-btn {
    height: 30px !important;
    background-color: darkblue !important;
    color: white;
    font-weight: bold;
    padding: 3px 10px !important;
  }

  .config-card {
    width: 100%;
    padding: 10px;
    margin-bottom: 20px;
  }

  @media (min-width: 768px) {
    .main-card {
      height: 800px;
    }

    .flyer-image {
      width: 50%;
    }

    .label14 {
      display: inline-block;
      width: 200px;
    }

    img {
      width: 600px;
    }
  }

</style>